import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CalendarPage, ModalEventSetPage } from './calendar';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
import {NgxPaginationModule} from 'ngx-pagination';


@NgModule({
  declarations: [
    CalendarPage,
    ModalEventSetPage,
  ],
  imports: [
    IonicPageModule.forChild(CalendarPage),
    CalendarModule,
    NgxPaginationModule,
  ],

  entryComponents: [
    ModalEventSetPage,
  ],
  providers: [
    RestProvider,
  ]
})
export class CalendarPageModule {}



// WEBPACK FOOTER //
// ./src/pages/calendar/calendar.module.ts